import React, { useEffect, useRef, useState } from 'react';
import { Route, useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAPI } from 'store/apiReducer';
import {
    Container,
    ModalV2,
    ModalV2Title,
    ModalV2Content,
    ModalV2Footer,
    Button,
} from '@si-armes/dsfr-react';
import * as PropTypes from 'prop-types';
import { getPath } from '../utils/router';
import Routes from './routes';
import DynamicTitle from './DynamicTitle';
import EspaceDetenteurs from './espace-detenteurs';
import FooterComponent from '../components/footer/FooterComponent';
import HeaderComponent from '../components/header/HeaderComponent';
import Compte from './compte';
import usagerClientReducer from '../store/usagerReducer';
import {
    API_GET_FEATURE_FLIPPING,
    API_GET_NOMBRE_NOTIFICATIONS,
    API_GET_PROFIL,
    CONTEXT_GET_FEATURE_FLIPPING,
    CONTEXT_GET_NOMBRE_NOTIFICATIONS,
    CONTEXT_GET_PROFIL,
} from '../constants/apiUrls.constants';
import Alerts from '../components/Alertes/Alertes';
import ContacterPrefecture from './espace-detenteurs/nous-contacter';
import ContacterPrefectureNonConnecte from './nous-contacter';
import MentionsLegales from './mentions-legales';
import DonneesPersonnelles from './donnees-personnelles';
import Deconnexion from './deconnexion';
import Accessibilite from './accessibilite';

const IndexPage = ({ getApi, dataProfil }) => {
    // Redirection provisoire car la page d'accueil n'a pas encore été réalisée.
    if (useLocation().pathname === getPath(Routes.subroutes.espaceDetenteurs)) {
        useHistory().push(getPath(Routes.subroutes.espaceDetenteurs.subroutes.ratelier));
    }

    const isConnecte = useLocation().pathname.includes(getPath(Routes.subroutes.espaceDetenteurs));
    const [displayModaleMiseAJourCompte, setDisplayModaleMiseAJourCompte] = useState(false);
    const { roles } = dataProfil || {};

    useEffect(() => {
        if (isConnecte) {
            getApi(usagerClientReducer, API_GET_PROFIL, CONTEXT_GET_PROFIL);
            getApi(
                usagerClientReducer,
                API_GET_NOMBRE_NOTIFICATIONS,
                CONTEXT_GET_NOMBRE_NOTIFICATIONS,
            );
        }
    }, [isConnecte]);

    useEffect(() => {
        getApi(usagerClientReducer, API_GET_FEATURE_FLIPPING, CONTEXT_GET_FEATURE_FLIPPING);
    }, []);

    const fermerModaleMiseAJourCompte = () => {
        setDisplayModaleMiseAJourCompte(false);
        window.location.href = process.env.REACT_APP_KEYCLOAK_LOGOUT_URI;
    };

    const dialog = useRef();

    useEffect(() => {
        if (dialog.current) {
            dialog.current.showModal();
        }
    }, [dialog]);

    return (
        <div>
            <HeaderComponent isConnecte={isConnecte} />
            <DynamicTitle />
            {!displayModaleMiseAJourCompte ? (
                <>
                    <Alerts />
                    <div className="position-relative" id="contenu" role="main">
                        <Container>
                            <Route
                                path={getPath(Routes.subroutes.espaceDetenteurs)}
                                render={(subProps) => <EspaceDetenteurs {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.nousContacterPublique)}
                                render={(subProps) => (
                                    <ContacterPrefectureNonConnecte {...subProps} />
                                )}
                            />
                            <Route
                                path={getPath(Routes.subroutes.mentionsLegales)}
                                render={(subProps) => <MentionsLegales {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.donneesPersonnelles)}
                                render={(subProps) => <DonneesPersonnelles {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.accessibilite)}
                                render={(subProps) => <Accessibilite {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.deconnexion)}
                                render={(subProps) => <Deconnexion {...subProps} />}
                            />
                            <Route
                                path={getPath(Routes.subroutes.nousContacterPrivee)}
                                render={(subProps) => (
                                    <ContacterPrefecture {...subProps} roles={roles} />
                                )}
                            />
                        </Container>
                        <Route
                            path={getPath(Routes.subroutes.compte)}
                            render={(subProps) => <Compte {...subProps} />}
                        />
                    </div>
                </>
            ) : (
                <ModalV2
                    id="miseAJour"
                    idModalTitle="miseAJour-titre"
                    size="lg"
                    onClose={fermerModaleMiseAJourCompte}
                    ref={dialog}
                >
                    <ModalV2Content>
                        <ModalV2Title id="miseAJour-titre">Mise à jour</ModalV2Title>

                        <p>
                            Vous allez être déconnecté de votre compte en raison d&apos;une mise à
                            jour du SIA. Merci de vous reconnecter
                        </p>
                    </ModalV2Content>
                    <ModalV2Footer>
                        <div className="fr-grid-row">
                            <div className="fr-col-12 btn-group-align-right">
                                <Button
                                    name="Confirmer"
                                    variant="primary"
                                    onClick={fermerModaleMiseAJourCompte}
                                >
                                    Confirmer
                                </Button>
                            </div>
                        </div>
                    </ModalV2Footer>
                </ModalV2>
            )}
            <FooterComponent isConnecte={isConnecte} />
        </div>
    );
};

IndexPage.propTypes = {
    getApi: PropTypes.func.isRequired,
    dataProfil: PropTypes.shape({
        numeroSia: PropTypes.string,
        roles: PropTypes.array,
    }),
};

export default connect(
    (state) => {
        const { data: dataProfil } = state.profil.usager;

        return {
            dataProfil,
        };
    },
    { getApi: getAPI },
)(IndexPage);
